/**
 * User Model for V2 Services
 */

export interface UserProfile {
  uid: string;
  email?: string;
  displayName?: string;
  phoneNumber?: string;
  photoURL?: string;
  isAdmin?: boolean;
  createdAt?: Date;
  lastLoginAt?: Date;
  lastSeenAt?: Date;
  metadata?: Record<string, any>;
}

export interface UserStats {
  totalBookings: number;
  completedBookings: number;
  cancelledBookings: number;
  totalSpent: number;
  averageRating?: number;
  lastBookingDate?: Date;
}

export class User {
  public uid: string;
  public email?: string;
  public displayName?: string;
  public phoneNumber?: string;
  public photoURL?: string;
  public isAdmin: boolean;
  public createdAt: Date;
  public lastLoginAt?: Date;
  public lastSeenAt?: Date;
  public metadata: Record<string, any>;
  public stats?: UserStats;

  constructor(data: Partial<UserProfile>) {
    this.uid = data.uid || '';
    this.email = data.email;
    this.displayName = data.displayName;
    this.phoneNumber = data.phoneNumber;
    this.photoURL = data.photoURL;
    this.isAdmin = data.isAdmin || false;
    this.createdAt = data.createdAt || new Date();
    this.lastLoginAt = data.lastLoginAt;
    this.lastSeenAt = data.lastSeenAt;
    this.metadata = data.metadata || {};
  }

  public toFirestore(): Record<string, any> {
    return {
      uid: this.uid,
      email: this.email,
      displayName: this.displayName,
      phoneNumber: this.phoneNumber,
      photoURL: this.photoURL,
      isAdmin: this.isAdmin,
      createdAt: this.createdAt,
      lastLoginAt: this.lastLoginAt,
      lastSeenAt: this.lastSeenAt,
      metadata: this.metadata,
      ...(this.stats && { stats: this.stats })
    };
  }

  public static fromFirestore(data: any): User {
    const user = new User(data);
    if (data.stats) {
      user.stats = data.stats;
    }
    return user;
  }

  public updateStats(updates: Partial<UserStats>): void {
    this.stats = { ...this.stats, ...updates } as UserStats;
  }
}